import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { handleNameSlice } from './utils';

const NameIconStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: #fff;
  background: #5687ff;
  border-radius: 11px;
  aspect-ratio: 1;
  font-size: 1em; /* 继承 NameIconStyled 的 font-size */

  .text {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1em; /* 继承 NameIconStyled 的 font-size */
  }

  .text-2 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
  }
`;

const NameIcon = ({ name, style }) => {
  const [texts, setTexts] = useState([]);

  useEffect(() => {
    setTexts(handleNameSlice(name));
  }, [name]);

  return (
    <NameIconStyled style={style}>
      {texts.length === 1 && <span className="text">{texts[0]}</span>}
      {texts.length === 2 && (
        <div className="text-2">
          <span className="text">{texts[0]}</span>
          <span className="text">{texts[1]}</span>
        </div>
      )}
      {texts.length === 3 && (
        <div className="text-3">
          <div className="text-2">
            <span className="text">{texts[0]}</span>
            <span className="text">{texts[1]}</span>
          </div>
          <span className="text">{texts[2]}</span>
        </div>
      )}
      {texts.length === 4 && (
        <div className="text-4">
          <div className="text-2">
            <span className="text">{texts[0]}</span>
            <span className="text">{texts[1]}</span>
          </div>
          <div className="text-2">
            <span className="text">{texts[2]}</span>
            <span className="text">{texts[3]}</span>
          </div>
        </div>
      )}
    </NameIconStyled>
  );
};

export default NameIcon;
